import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaLinkedinIn } from 'react-icons/fa';
import './Team.css';

const Team = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const team = [
    {
      name: 'Malachi Alper',
      role: 'Active Chairman',
      image: '/Malachi Alper.png',
      description: 'A seasoned C-level executive with 4 decades of experience as CEO in energy and petrochemicals, including two refineries; globally recognized industry expert',
      linkedin: 'https://www.linkedin.com/in/malachi-alper-43a70336/'
    },
    {
      name: 'Dr. Uri Givan',
      role: 'Co-Founder and CEO',
      image: '/Uri Givan.png',
      description: 'Physicist and entrepreneur with broad experience in renewables, Waste2X and climate-tech startups',
      linkedin: 'https://www.linkedin.com/in/uri-givan-7867948/'
    },
    {
      name: 'Dr. Netta Mentovich',
      role: 'Co-Founder and Head of Chemistry',
      image: '/Netta Mentovich.png',
      description: 'Chemist (TAU) with broad experience in analytical methods and leadership of industrial Research & Development',
      linkedin: 'https://www.linkedin.com/in/netta-hendler-mentovich-6608b298/'
    },
    {
      name: 'Shmulik Kollender',
      role: 'COO & CFO',
      image: '/Shmulik Kollerder.png',
      description: 'C-level executive with a track record of building and growing startups and global companies across various regions',
      linkedin: 'https://www.linkedin.com/in/shmulik-kollender-b8b66153/'
    },
    {
      name: 'Sophie Tuviahu',
      role: 'CBO',
      image: '/Sophie Tuviahu.png',
      description: 'C-level executive with a track record of building successful strategic partnerships while scaling new technologies',
      linkedin: 'https://www.linkedin.com/in/sophie-tuviahu-11725779/'
    },
  ];

  return (
    <section id="team" className="team" ref={ref}>
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Our Team</h2>
          <p className="section-subtitle">Experienced leadership with proven track record in large-scale industrial projects</p>
        </motion.div>

        <div className="team-grid">
          {team.map((member, index) => (
            <motion.div
              key={index}
              className="team-member"
              initial={{ opacity: 0, scale: 0.5 }}
              animate={inView ? { opacity: 1, scale: 1 } : {}}
              transition={{
                duration: 0.6,
                delay: index * 0.1,
              }}
            >
              <div className="member-image-wrapper">
                <img src={member.image} alt={member.name} className="member-image" />
                <div className="member-overlay"></div>
              </div>
              <motion.div 
                className="member-info"
                whileHover={{
                  scale: 1.05,
                  y: -5,
                }}
                transition={{ duration: 0.3 }}
              >
                <h3>{member.name}</h3>
                <p className="member-role">{member.role}</p>
                <p className="member-description">{member.description}</p>
                <a href={member.linkedin} className="linkedin-icon" aria-label="LinkedIn profile">
                  <FaLinkedinIn />
                </a>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
